export const allowedPageNames = (idPagesText, pages) => {
  if (!idPagesText) return [];

  const allowedIds = idPagesText
    .split(",")
    .filter((item) => item.trim() !== "")
    .map((item) => parseInt(item.split(".")[0], 10))
    .filter((id) => !isNaN(id));

  return pages
    .filter((page) => allowedIds.includes(page.idPage))
    .map((page) => page.name);
};
